import { Component } from '@angular/core';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';

@Component({
  selector: 'app-mens-intimate-wash-bacterial-vaginosis',
  imports: [MensIntimateWashComponent],
  templateUrl: './mens-intimate-wash-bacterial-vaginosis.component.html',
})
export class MensIntimateWashBacterialVaginosisComponent {}
